import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
danger,
success,
showLoading,
} from "../../../components/show-notification";
import api from "../../../providers/api";
import LoadingPanel from "../../../components/loading-painel";
import Layout from "../../../layout";
import validate from "./form-validate";
const ProdutoCadastrar = () => {
const location = useLocation();
const history = useHistory();
const [stateCategorias, setStateCategorias] = useState([]);
const [stateCaracteristicas, setStateCaracteristicas] = useState([]);
const [tabAtivaState, setTabAtivaState] = useState("");
const [state, setState] = useState({
id: 0,
categoria_id: "",
codigo: "",
nome: "",
descricao: "",
ficha_tecnica: "",
visao_geral: "",
especificacao: "",
acessorios: "",
ordem: "",
nome_in: "",
descricao_in: "",
ficha_tecnica_in: "",
visao_geral_in: "",
especificacao_in: "",
acessorios_in: "",
nome_es: "",
descricao_es: "",
ficha_tecnica_es: "",
visao_geral_es: "",
especificacao_es: "",
acessorios_es: "",
imagem: [],
imagens: [],
caracteristicas: [],
});
let preencherValoresEdits = (event) => {
setState({ ...state, [event.target.name]: event.target.value });
};
const enviarFormulario = async (e) => {
e.preventDefault();
if (!window.$("#form-produto").valid()) {
return;
}
try {
const formData = new FormData();
formData.append("id", state.id);
formData.append("categoria_id", state.categoria_id);
formData.append("codigo", state.codigo);
formData.append("ordem", state.ordem);
formData.append("nome", state.nome);
formData.append("descricao", state.descricao);
formData.append("ficha_tecnica", state.ficha_tecnica);
formData.append("visao_geral", state.visao_geral);
formData.append("especificacao", state.especificacao);
formData.append("acessorios", state.acessorios);
formData.append("nome_in", state.nome_in);
formData.append("descricao_in", state.descricao_in);
formData.append("ficha_tecnica_in", state.ficha_tecnica_in);
formData.append("visao_geral_in", state.visao_geral_in);
formData.append("especificacao_in", state.especificacao_in);
formData.append("acessorios_in", state.acessorios_in);
formData.append("nome_es", state.nome_es);
formData.append("descricao_es", state.descricao_es);
formData.append("ficha_tecnica_es", state.ficha_tecnica_es);
formData.append("visao_geral_es", state.visao_geral_es);
formData.append("especificacao_es", state.especificacao_es);
formData.append("acessorios_es", state.acessorios_es);
formData.append("caracteristicas", JSON.stringify(state.caracteristicas));
if (state.imagem) {
for (var i = 0; i < state.imagem.length; i++) {
var file = state.imagem[i];
formData.append("imagem[]", file);
}
}
const enviar = state.id > 0 ? api.put : api.post;
const requisicao = await enviar("/produto", formData);
const { data } = requisicao;
if (!data.status) {
danger(data.mensagem);
return;
}
if (!data.data) {
return;
}
success(data.mensagem);
history.push("/produto");
} catch (error) {
console.log(error);
danger("Erro ao cadastrar o produto.");
}
};
const excluirImagem = (id) => {
window.swal(
{
title: "Você tem certeza?",
text: `Deseja realmente excluir a imagem?`,
type: "warning",
showCancelButton: true,
confirmButtonColor: "#DD6B55",
confirmButtonText: "Confirmar",
cancelButtonText: "Cancelar",
closeOnConfirm: true,
},
async () => {
try {
const { data } = await api.delete(`/produto/imagem/${id}`);
if (!data.status) {
danger(data.mensagem);
return;
}
success(data.mensagem);
carregarTodosDados();
} catch (error) {
console.log(error);
danger("Erro ao deletar a imagem");
}
}
);
};
const buscarDados = async (url) => {
const requisicao = await api.get(`${url}`);
const { data } = requisicao;
if (!data.status) {
danger(data.mensagem);
return;
}
if (!data.data) {
return;
}
return data.data;
};
const carregarCategorias = async () => {
return await buscarDados("/categoria");
};
const carregarCaracteristicas = async () => {
return await buscarDados("/caracteristica");
};
const carregarDados = async () => {
if (!location.state) {
return;
}
return await buscarDados(`/produto/${location.state.id}`);
};
const carregarTodosDados = async () => {
try {
showLoading(".ibox-content");
const [categorias, caracteristicas, produto] = await Promise.all([
carregarCategorias(),
carregarCaracteristicas(),
carregarDados(),
]);
setStateCategorias(categorias);
setStateCaracteristicas(caracteristicas);
if (produto) {
setState(produto);
}
showLoading(".ibox-content");
} catch (error) {
console.log(error);
showLoading(".ibox-content");
danger("Erro ao carregar os dados do produto");
}
};
useEffect(() => {
let validacao = window.$("#form-produto").validate(validate);
carregarTodosDados();
return () => validacao.destroy();
}, [location.state]);
const handleChangeCaracteristica = (event, caracteristica) => {
event.preventDefault();
let existe =
state.caracteristicas.filter(
(c) => c.caracteristica_id === caracteristica.id
).length > 0;
if (existe) {
window.swal(
{
title: "Você tem certeza?",
text: `Deseja realmente excluir a característica?`,
type: "warning",
showCancelButton: true,
confirmButtonColor: "#DD6B55",
confirmButtonText: "Confirmar",
cancelButtonText: "Cancelar",
closeOnConfirm: true,
},
() => {
setState({
...state,
caracteristicas: state.caracteristicas.filter(
(c) => c.caracteristica_id !== caracteristica.id
),
});
}
);
return;
}
const newState = Object.assign({}, state);
newState.caracteristicas.push({
id: 0,
produto_id: newState.id,
caracteristica_id: caracteristica.id,
detalhamentos: [],
});
setState(newState);
};
const handleChangeDetalhamento = (event, caracteristica, detalhamento) => {
event.preventDefault();
let existe =
caracteristica.detalhamentos.filter(
(d) => d.detalhamento_id === detalhamento.id
).length > 0;
if (existe) {
window.swal(
{
title: "Você tem certeza?",
text: `Deseja realmente excluir o detalhamento?`,
type: "warning",
showCancelButton: true,
confirmButtonColor: "#DD6B55",
confirmButtonText: "Confirmar",
cancelButtonText: "Cancelar",
closeOnConfirm: true,
},
() => {
const newState = Object.assign({}, state);
newState.caracteristicas = newState.caracteristicas.map((car) => {
if (car.caracteristica_id === caracteristica.caracteristica_id) {
car.detalhamentos = car.detalhamentos.filter(
(d) => d.detalhamento_id !== detalhamento.id
);
}
return car;
});
setState(newState);
}
);
return;
}
const newState = Object.assign({}, state);
newState.caracteristicas = newState.caracteristicas.map((car) => {
if (car.caracteristica_id === caracteristica.caracteristica_id) {
car.detalhamentos.push({
id: 0,
produto_caracteristica_id: car.id,
detalhamento_id: detalhamento.id,
});
}
return car;
});
setState(newState);
};
return (
<>
<Layout
titulo="Ibraflex - Produtos"
header="Cadastro do Produto"
action={{ titulo: "Voltar", link: "/produto" }}
>
<div className="row">
   <div className="col-lg-12">
      <div className="ibox ">
         <div className="ibox-title">
            <h5>Dados do produto</h5>
         </div>
         <div className="ibox-content">
            <LoadingPanel />
            <div className="row">
               <div className="col-lg-12">
                  <form id="form-produto">
                     <div className="row">
                        <div className="col-lg-12">
                           <div className="tabs-container">
                              <div className="form-group">
                                 <ul className="nav nav-tabs">
                                    <li>
                                       <a
                                          className="nav-link active"
                                          data-toggle="tab"
                                          href="#tab-produto"
                                          >
                                       Produto
                                       </a>
                                    </li>
                                    <li>
                                       <a
                                          className="nav-link"
                                          data-toggle="tab"
                                          href="#tab-caracteristica"
                                          >
                                       Característica
                                       </a>
                                    </li>
                                    <li>
                                       <a
                                          className="nav-link"
                                          data-toggle="tab"
                                          href="#tab-detalhamento"
                                          >
                                       Detalhamento
                                       </a>
                                    </li>
                                 </ul>
                                 <div className="tab-content">
                                    <div
                                       id="tab-produto"
                                       className="tab-pane active"
                                       >
                                       <div className="panel-body">
                                          <div className="row">
                                             <div className="col-lg-4">
                                                <div className="form-group">
                                                   <label>Selecione a categoria</label>
                                                   <select
                                                      className="form-control"
                                                      id="categoria_id"
                                                      name="categoria_id"
                                                      value={state.categoria_id}
                                                      onChange={(e) =>
                                                      preencherValoresEdits(e)
                                                      }
                                                      >
                                                      <option key="-1" value="">
                                                         Selecione uma categoria
                                                      </option>
                                                      {stateCategorias.map(
                                                      (categoria) => (
                                                      <option
                                                         key={categoria.id}
                                                         value={categoria.id}
                                                         >
                                                         {categoria.nome}
                                                      </option>
                                                      )
                                                      )}
                                                   </select>
                                                </div>
                                             </div>
                                             <div className="col-lg-4">
                                                <div className="form-group">
                                                   <label>Imagens do produto</label>
                                                   <input
                                                      type="file"
                                                      placeholder="Imagens do produto"
                                                      className="form-control"
                                                      id="imagem"
                                                      name="imagem"
                                                      accept="image/mp4/*"
                                                      multiple="multiple"
                                                      onChange={(e) =>
                                                   setState({
                                                   ...state,
                                                   imagem: e.target.files,
                                                   })
                                                   }
                                                   />
                                                </div>
                                             </div>
                                             <div className="col-lg-2">
                                                <div className="form-group">
                                                   <label>Código do produto</label>
                                                   <input
                                                      type="text"
                                                      placeholder="Código do produto"
                                                      className="form-control"
                                                      name="codigo"
                                                      value={state.codigo}
                                                      onChange={(e) =>
                                                   preencherValoresEdits(e)
                                                   }
                                                   />
                                                </div>
                                             </div>
                                             <div className="col-lg-2">
                                                <div className="form-group">
                                                   <label>Ordem do produto</label>
                                                   <input
                                                      type="text"
                                                      placeholder="Ordem do produto"
                                                      className="form-control"
                                                      name="ordem"
                                                      value={state.ordem}
                                                      onChange={(e) =>
                                                   preencherValoresEdits(e)
                                                   }
                                                   />
                                                </div>
                                             </div>
                                          </div>
                                          <div className="row">
                                             <div className="col-lg-12">
                                                <div className="form-group">
                                                   <div className="tabs-container">
                                                      <ul
                                                         className="nav nav-tabs"
                                                         role="tablist"
                                                         >
                                                         <li>
                                                            <a
                                                               className="nav-link active"
                                                               data-toggle="tab"
                                                               href="#tab-1"
                                                               >
                                                            Português
                                                            </a>
                                                         </li>
                                                         <li>
                                                            <a
                                                               className="nav-link"
                                                               data-toggle="tab"
                                                               href="#tab-2"
                                                               >
                                                            Inglês
                                                            </a>
                                                         </li>
                                                         <li>
                                                            <a
                                                               className="nav-link"
                                                               data-toggle="tab"
                                                               href="#tab-3"
                                                               >
                                                            Espanhol
                                                            </a>
                                                         </li>
                                                      </ul>
                                                      <div className="tab-content">
                                                         <div
                                                            role="tabpanel"
                                                            id="tab-1"
                                                            className="tab-pane active"
                                                            >
                                                            <div className="panel-body">
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Nome do produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Nome do produto"
                                                                           className="form-control"
                                                                           name="nome"
                                                                           value={state.nome}
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Descrição do produto
                                                                        </label>
                                                                        <textarea
                                                                           className="form-control"
                                                                           id="descricao"
                                                                           name="descricao"
                                                                           placeholder="Descrição da empresa."
                                                                           rows="3"
                                                                           value={
                                                                           state.descricao
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Ficha técnica do
                                                                        produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Ficha ténica do produto"
                                                                           className="form-control"
                                                                           name="ficha_tecnica"
                                                                           value={
                                                                           state.ficha_tecnica
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Visão geral do produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Visão geral do produto"
                                                                           className="form-control"
                                                                           name="visao_geral"
                                                                           value={
                                                                           state.visao_geral
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Especificação do
                                                                        produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Especificação do produto"
                                                                           className="form-control"
                                                                           name="especificacao"
                                                                           value={
                                                                           state.especificacao
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Acessórios do produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Acessórios do produto"
                                                                           className="form-control"
                                                                           name="acessorios"
                                                                           value={
                                                                           state.acessorios
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                            </div>
                                                         </div>
                                                         <div
                                                            role="tabpanel"
                                                            id="tab-2"
                                                            className="tab-pane"
                                                            >
                                                            <div className="panel-body">
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Nome do produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Nome do produto"
                                                                           className="form-control"
                                                                           name="nome_in"
                                                                           value={state.nome_in}
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Descrição do produto
                                                                        </label>
                                                                        <textarea
                                                                           className="form-control"
                                                                           id="descricao_in"
                                                                           name="descricao_in"
                                                                           placeholder="Descrição da empresa."
                                                                           rows="3"
                                                                           value={
                                                                           state.descricao_in
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Ficha técnica do
                                                                        produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Ficha ténica do produto"
                                                                           className="form-control"
                                                                           name="ficha_tecnica_in"
                                                                           value={
                                                                           state.ficha_tecnica_in
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Visão geral do produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Visão geral do produto"
                                                                           className="form-control"
                                                                           name="visao_geral_in"
                                                                           value={
                                                                           state.visao_geral_in
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Especificação do
                                                                        produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Especificação do produto"
                                                                           className="form-control"
                                                                           name="especificacao_in"
                                                                           value={
                                                                           state.especificacao_in
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Acessórios do produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Acessórios do produto"
                                                                           className="form-control"
                                                                           name="acessorios_in"
                                                                           value={
                                                                           state.acessorios_in
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                            </div>
                                                         </div>
                                                         <div
                                                            role="tabpanel"
                                                            id="tab-3"
                                                            className="tab-pane"
                                                            >
                                                            <div className="panel-body">
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Nome do produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Nome do produto"
                                                                           className="form-control"
                                                                           name="nome_es"
                                                                           value={state.nome_es}
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Descrição do produto
                                                                        </label>
                                                                        <textarea
                                                                           className="form-control"
                                                                           id="descricao_es"
                                                                           name="descricao_es"
                                                                           placeholder="Descrição da empresa."
                                                                           rows="3"
                                                                           value={
                                                                           state.descricao_es
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Ficha técnica do
                                                                        produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Ficha ténica do produto"
                                                                           className="form-control"
                                                                           name="ficha_tecnica_es"
                                                                           value={
                                                                           state.ficha_tecnica_es
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Visão geral do produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Visão geral do produto"
                                                                           className="form-control"
                                                                           name="visao_geral_es"
                                                                           value={
                                                                           state.visao_geral_es
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Especificação do
                                                                        produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Especificação do produto"
                                                                           className="form-control"
                                                                           name="especificacao_es"
                                                                           value={
                                                                           state.especificacao_es
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                               <div className="row">
                                                                  <div className="col-lg-12">
                                                                     <div className="form-group">
                                                                        <label>
                                                                        Acessórios do produto
                                                                        </label>
                                                                        <input
                                                                           type="text"
                                                                           placeholder="Acessórios do produto"
                                                                           className="form-control"
                                                                           name="acessorios_es"
                                                                           value={
                                                                           state.acessorios_es
                                                                           }
                                                                           onChange={(e) =>
                                                                        preencherValoresEdits(
                                                                        e
                                                                        )
                                                                        }
                                                                        />
                                                                     </div>
                                                                  </div>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <div
                                       id="tab-caracteristica"
                                       className="tab-pane"
                                       >
                                       <div className="panel-body">
                                          <div className="row">
                                             {stateCaracteristicas &&
                                             stateCaracteristicas.length > 0 ? (
                                             stateCaracteristicas.map(
                                             (caracteristica) => (
                                             <div
                                                className="col-lg-4"
                                                key={Math.random()}
                                                >
                                                <div className="form-group">
                                                   <div
                                                      className="toast toast-bootstrap show"
                                                      role="alert"
                                                      aria-live="assertive"
                                                      aria-atomic="true"
                                                      >
                                                      <div
                                                      className={`toast-header ${
                                                      state.caracteristicas.filter(
                                                      (c) =>
                                                      c.caracteristica_id ===
                                                      caracteristica.id
                                                      ).length > 0
                                                      ? "bg-success"
                                                      : "bg-muted"
                                                      }`}
                                                      >
                                                      <i className="fa fa-tag" />
                                                      <strong className="mr-auto m-l-sm">
                                                      Característica
                                                      </strong>
                                                      {state.caracteristicas.filter(
                                                      (c) =>
                                                      c.caracteristica_id ===
                                                      caracteristica.id
                                                      ).length > 0 ? (
                                                      <small>
                                                      <i className="fa fa-check"></i>
                                                      </small>
                                                      ) : null}
                                                   </div>
                                                   <div className="toast-body">
                                                      <div className="row">
                                                         <div className="col col-lg-12">
                                                            Código: {""}
                                                            <strong>
                                                            {caracteristica.id}
                                                            </strong>
                                                         </div>
                                                      </div>
                                                      <div className="row">
                                                         <div className="col col-lg-12">
                                                            Nome: {""}
                                                            <strong>
                                                            {caracteristica.nome}
                                                            </strong>
                                                         </div>
                                                      </div>
                                                      <div className="row">
                                                         <div className="col col-lg-12">
                                                            Status: {""}
                                                            <strong>
                                                            {caracteristica.ativo ? (
                                                            <span className="badge badge-primary">
                                                            Ativo
                                                            </span>
                                                            ) : (
                                                            <span className="badge badge-warning">
                                                            Inativo
                                                            </span>
                                                            )}
                                                            </strong>
                                                         </div>
                                                      </div>
                                                      <div className="row">
                                                         <div className="col col-lg-12">
                                                            <button
                                                            className={`btn btn-xs float-right ${
                                                            state.caracteristicas.filter(
                                                            (c) =>
                                                            c.caracteristica_id ===
                                                            caracteristica.id
                                                            ).length > 0
                                                            ? "btn-danger"
                                                            : "btn-success"
                                                            }`}
                                                            onClick={(e) =>
                                                            handleChangeCaracteristica(
                                                            e,
                                                            caracteristica
                                                            )
                                                            }
                                                            >
                                                            {state.caracteristicas.filter(
                                                            (c) =>
                                                            c.caracteristica_id ===
                                                            caracteristica.id
                                                            ).length > 0
                                                            ? "Remover"
                                                            : "Adicionar"}
                                                            </button>
                                                         </div>
                                                      </div>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                          )
                                          )
                                          ) : (
                                          <div className="row">
                                             <div className="col col-lg-12">
                                                <div className="form-group">
                                                   <strong>
                                                   Nenhuma característica
                                                   cadastrada.
                                                   </strong>
                                                </div>
                                             </div>
                                          </div>
                                          )}
                                       </div>
                                    </div>
                                 </div>
                                 <div id="tab-detalhamento" className="tab-pane">
                                    <div className="panel-body">
                                       <div className="row">
                                          <div className="col-lg-12">
                                             <div className="tabs-container">
                                                <div className="form-group">
                                                   {state.caracteristicas.length >
                                                   0 ? (
                                                   <>
                                                   <ul className="nav nav-tabs">
                                                      {state.caracteristicas.map(
                                                      (caracteristica) => {
                                                      let car =
                                                      stateCaracteristicas.find(
                                                      (c) =>
                                                      c.id ===
                                                      caracteristica.caracteristica_id
                                                      );
                                                      if (car) {
                                                      return (
                                                      <li
                                                         key={Math.random()}
                                                         >
                                                         <a
                                                         className={`nav-link ${
                                                         (car.id ===
                                                         state
                                                         .caracteristicas[0]
                                                         .caracteristica_id &&
                                                         tabAtivaState ===
                                                         "") ||
                                                         tabAtivaState ===
                                                         `#tab-detalhamento-${car.id}`
                                                         ? "active"
                                                         : ""
                                                         }`}
                                                         data-toggle="tab"
                                                         href={`#tab-detalhamento-${car.id}`}
                                                         onClick={(e) =>
                                                         setTabAtivaState(
                                                         `#tab-detalhamento-${car.id}`
                                                         )
                                                         }
                                                         >
                                                         {car.nome}
                                                         </a>
                                                      </li>
                                                      );
                                                      }
                                                      }
                                                      )}
                                                   </ul>
                                                   
                                             </>
                                             ) : (
                                             <div className="row">
                                                <div className="col col-lg-12">
                                                   <div className="form-group">
                                                      <strong>
                                                      Nenhuma característica
                                                      selecionada.
                                                      </strong>
                                                   </div>
                                                </div>
                                             </div>
                                             )}
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
               </div>
            </div>
         </div>
         <div>
         <button
            className="btn btn-sm btn-success float-right m-t-n-xs"
            type="submit"
            onClick={(e) => enviarFormulario(e)}
         >
         <strong>Salvar</strong>
         </button>
         </div>
         </form>
      </div>
   </div>
</div>
</div>
</div>
</div>
<div className="row">
   <div className="col-lg-12">
      <div className="ibox ">
         <div className="ibox-title">
            <h5>Imagens do produto</h5>
         </div>
         <div className="ibox-content">
            <LoadingPanel />
            <div className="row">
               <div className="col-lg-12">
                  {state.imagens.map((imagem) => (
                  <div className="file-box">
                     <div className="file">
                        <a href={imagem.url} target="_blank" rel="noreferrer">
                           <span className="corner"></span>
                           <div className="image">
                              <img
                                 alt="image"
                                 className="img-fluid"
                                 src={imagem.url}
                                 />
                           </div>
                        </a>
                        <div
                        className="file-name"
                        style={{ textAlign: "center" }}
                        >
                        <button
                           className="btn btn-danger btn-xs"
                           id="alerta-excluir"
                           onClick={(e) => {
                        e.preventDefault();
                        excluirImagem(imagem.id);
                        }}
                        >
                        Excluir
                        </button>
                     </div>
                  </div>
               </div>
               ))}
            </div>
         </div>
      </div>
   </div>
</div>
</div>
</Layout>
</>
);
};
export default ProdutoCadastrar;